
/* System defined core library */
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnChanges, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import * as $ from 'jquery';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

/* User defined library/components */
import { SelectedExamDetailService } from '../../../scheduling/shared/services/selected-exam-detail.service';
import { UtilityService } from '../../../shared/services/utility.service';

/* User defined models */
import { HighLightDates } from '../../models/common/date.model';
import { Slot } from '../../models/scheduling/slot.model';
import { SiteSlot } from '../../models/scheduling/siteSlot.model';
import { State } from '../../models/scheduling/state.model';

@Component({
  selector: 'popover',
  host: {
    '(document:click)': 'handleClick($event)',
  },
  templateUrl: 'popover.component.html',
  styleUrls: ['./popover.component.scss']
})

export class PopoverComponent implements OnChanges {

  /* User defined private/public variables  */
  public popoverEnabled: boolean = false;

  public selectedLocationName: string = '';
  public formattedAddress: string;
  public locationDataSource: Observable<any>;
  public elementRef: any;
  public outerUpdateRef: boolean = false;
  public currentDate: any;
  public highLightedDates: HighLightDates;
  public selectedLocation: string;
  public formattedDate: any;

  public today = new Date();

  public startDateOptions: kendo.ui.DatePickerOptions;
  public placeHolderText: string;

  /* Input-OutPut parameters decalartions */
  @Input() geolocation: any[];
  @Input() geolocationChange: any[];
  @Input() public title: string = 'Title';
  @Input() public content: string = 'Long Decription ...';
  @Input() public placement: string = 'top';
  @Input() public actionTxt: string = "popoverComponent.clickMe";
  @Input() public actionTxtAriaSupplement: string;
  @Input() public isSlotSelected: boolean = false;
  @Input() public data: any = {};
  @Input() public locationSelector: boolean = false;
  @Input() public showHeaderFooter: boolean = false;
  @Input() public appliedClass: string = "navAction";
  @Input() public showDatePicker: boolean = true;
  @Input() public refBlock: string = "";
  @Input() public activeDate: any;
  @Input() public region: State;
  @Input() public defaultMonth: string;
  @Input() public overLapEndDate: any;
  @Input() public overLapStartDate: any;
  @Input() public selectedDate: any;
  @Input() public section: string;
  @Input() public focusChildElement: string;
  @Input() public myDateRangePickerOptions: any;
  @Input() public selectedStartDate: any;
  @Input() public selectedEndDate: any;
  @Input() public indicateInvalidDateRange: boolean;
  @Input() public maxDays: number;
  @Input() public noSessionAvailability: boolean;
  @Input() public datepickerId: string;
  @Input() public preventDatepickerClose: boolean;

  @ViewChild('slotsWrpr') elSlotsWrpr: ElementRef;
  @ViewChild('locationSelector') elLocationSelector: ElementRef;
  @ViewChild('calendarWrpr') elCalendarWrpr: ElementRef;

  @Output() public SelectedDate: EventEmitter<any> = new EventEmitter();
  @Output() public SelectedStartDate: EventEmitter<any> = new EventEmitter();
  @Output() public SelectedEndDate: EventEmitter<any> = new EventEmitter();
  @Output() public GetSiteData: EventEmitter<any> = new EventEmitter();
  @Output() public outerUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public IsAnyChange: EventEmitter<any> = new EventEmitter();
  @Output() public setPlaceHolder = new EventEmitter<any>();
  @Output() public focusParentElement: EventEmitter<string> = new EventEmitter();

  /* Service subscriptions */
  selectedStartDate$: Subscription;
  translateLanguage$: Subscription;

  /* Constructor declaration with required injected services */
  public constructor(
    private selectedExamDetailService: SelectedExamDetailService,
    private utilityService: UtilityService,
    private router: Router,
    private myElement: ElementRef,
    private ref: ChangeDetectorRef,
    private translate: TranslateService
  ) {

    this.elementRef = myElement;
    this.locationDataSource = new Observable
      ((observer: any) => {
        observer.next(this.geolocation);
      })
      .pipe(mergeMap((token: any) => this.getLocation(token)));
    this.highLightedDates = new HighLightDates();
    translate.setDefaultLang(this.selectedExamDetailService.defaultLanguageCode);
    this.translateLanguage$ = selectedExamDetailService.languageCode.subscribe(
      languageCode => {
        translate.use(languageCode);
      }
    );

    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    }

    this.placeHolderText = this.selectedExamDetailService.dateFormat.toUpperCase();
  }

  /* Initialize the component & call require methods when component loaded first time. */
  ngOnInit() {
    this.startDateOptions = {
      format: this.selectedExamDetailService.dateFormat,
      culture: this.selectedExamDetailService.browserCulture,
      min: this.getValidStart(),
      max: this.getValidStartDateEnd(),
      start: "month",
      disableDates: [this.today]
    }

    if (this.region) {
      this.formattedAddress = this.region.name;
      this.selectedLocationName = this.region.name;
      this.setPlaceHolder.emit(this.formattedAddress);
    }

    this.currentDate = (!this.utilityService.isNullOrUndefined(this.selectedDate)) ?
      moment(new Date(this.selectedDate['jsdate'])).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD');
  }

  /* Set flag if slot is selected */
  slotChange(event: any): void {
    if (this.refBlock == "MoreDate") {
      this.isSlotSelected = true;
    }
  }

  /* Emit date if changed  */
  dateChange(date: any, pop: any): void {
    this.isSlotSelected = false;
    if (this.refBlock !== "MoreDate" && this.refBlock !== 'SessionDate' && this.refBlock !== 'DateRangePicker') {
      this.togglePopover(event, pop);
    }
    this.selectedDate = date;
    //this.SelectedDate.emit(date);
    this.currentDate = moment(new Date(date['jsdate'])).format('YYYY-MM-DD');
    this.formattedDate = moment(new Date(this.selectedDate['jsdate'])).format('ddd, MMM YYYY');
    this.isSlotSelected = true;
    if (this.refBlock == 'MoreDate') {
      this.GetSiteData.emit(date);
      this.focusChildElement = 'slotsWrpr';
    }

    if (this.refBlock === 'SessionDate') {
      this.GetSiteData.emit(date);
      setTimeout(() => {
        if (!this.noSessionAvailability) $('.popover').hide();
      }, 1);
    }
  }

  noSlotAvailability() {
    return !!this.data && !!this.data.slots && this.data.slots.length == 0;
  }

  setSelectedStartDate(date: any, pop: any): void {
    this.SelectedStartDate.emit(date);
  }

  setSelectedEndDate(event: any, pop: any): void {
    this.SelectedEndDate.emit(event);
    $('.popover').hide();
  }


  /* Emit the new slected slot to parent if user has changed   */
  updateSlectedSlot(event: any, pop: any, selectedSite: SiteSlot, selectedSlot: Slot): void {
    this.selectedExamDetailService.setSiteSlot(selectedSite);
    this.selectedExamDetailService.setSlot(selectedSlot);
    this.SelectedDate.emit(this.selectedDate);
    this.focusParentElement.emit(pop);
    this.togglePopover(event, pop);
    this.IsAnyChange.emit({ activeDate: this.selectedDate, selectedSite: selectedSite, selectedSlot: selectedSlot });
  }

  togglePopover(event: any, currentPopUp: any): void {
    // TODO: Find best approach to fix this.
    let temp = this.utilityService.deepCompare(currentPopUp, this.selectedExamDetailService.prevSelectedPopoverObject);
    if (!temp && this.selectedExamDetailService.prevSelectedPopoverObject != undefined && this.selectedExamDetailService.prevSelectedPopoverObject != null) {
      this.selectedExamDetailService.prevSelectedPopoverObject.toggle();
    }
    else if (temp && this.selectedExamDetailService.prevSelectedPopoverObject != undefined
      && this.selectedExamDetailService.prevSelectedPopoverObject != null
      && event.target && event.target.className == "btn btn-success select") {
      this.selectedExamDetailService.prevSelectedPopoverObject.toggle();
    }

    this.selectedExamDetailService.prevSelectedPopoverObject = currentPopUp;
    this.selectedExamDetailService.outsidesClick = 1;
    if (!this.popoverEnabled) {
      this.popoverEnabled = true;
      this.isSlotSelected = false;
    } else {
      this.popoverEnabled = false;
    }
    $('.popover').hide();
    currentPopUp.toggle();

    // Change attribute default property from tooltip to dialog.
    // Task 333456:Ensure dialogs use proper structure
    let roleAttribute = document.createAttribute("role");
    roleAttribute.value = "dialog";

    let arialableAttribute = document.createAttribute("aria-label");
    arialableAttribute.value = "Update Testing Location";

    if ($(event.target).attr('id') != 'cancelPopup' &&
      !this.utilityService.isNullOrUndefined(currentPopUp.popover) ||
      (!this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling) &&
        !this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling))
      ||
      (!this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextSibling) &&
        !this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextSibling.nextSibling))
    ) {

      if ((!this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling) &&
        !this.utilityService.isNullOrUndefined(currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling))) {
        currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling.setAttributeNode(roleAttribute);
        currentPopUp.popover.elementRef.nativeElement.nextElementSibling.nextElementSibling.setAttributeNode(arialableAttribute);
      }
      else // Fix for I.E
      {
        currentPopUp.popover.elementRef.nativeElement.nextSibling.nextSibling.setAttributeNode(roleAttribute);
        currentPopUp.popover.elementRef.nativeElement.nextSibling.nextSibling.setAttributeNode(arialableAttribute);
      }
    }

    if ($(event.target).attr('id') == 'cancelPopup') {
      this.selectedExamDetailService.prevSelectedPopoverObject = null;
      this.focusParentElement.emit(currentPopUp);
    }
    if (temp && this.selectedExamDetailService.prevSelectedPopoverObject != undefined
      && this.selectedExamDetailService.prevSelectedPopoverObject != null
      && event.target && event.target.className.indexOf("btn secNavAction") > -1) {
      this.selectedExamDetailService.prevSelectedPopoverObject = null;
      this.selectedExamDetailService.outsidesClick = 0;
    }
  }

  /* Get the location selected by user and emit to parent */
  getGeoLocation(event: any, value: any, pop: any): void {
    let stateVal: State = { id: '', lat: this.selectedLocation[0], long: this.selectedLocation[1], uri: '', name: this.selectedLocation[2] };
    this.selectedExamDetailService.setRegion(stateVal);
    this.formattedAddress = stateVal.name;
    this.selectedLocationName = stateVal.name;
    this.outerUpdate.emit(this.outerUpdateRef);
    this.focusParentElement.emit(pop);
    this.togglePopover(event, pop);
    this.selectedExamDetailService.outsidesClick = 0;
  }

  /* Hide all pop over if user has clicked outside anywhere */
  public handleClick(event: any) {
    // Prevent toggling popover when a date is selected from calendar
    if ($(event.target).parents("table.k-calendar-table, div.k-calendar").length) {
      return;
    }

    if (($(event.target).parents("popover, popover-container, [id^='datepicker']").length ||
      $(event.target).attr('id') == 'cancelPopup') &&
      ($(event.target).attr('class') == undefined ||
        ($(event.target).attr('class') != undefined && $(event.target).attr('class').indexOf('btnpicker') == -1))) {
      this.selectedExamDetailService.outsidesClick = 1;
      return;
    }
    var clickedComponent = event.target;
    var inside = false;

    if (clickedComponent === this.elementRef.nativeElement) {
      inside = true;
    }
    if (clickedComponent.type == "button") {
      inside = true;
    }

    if (inside) {

    }
    else {
      if (this.selectedExamDetailService.outsidesClick == 1) {
        this.popoverEnabled = false;
        if (this.selectedExamDetailService.prevSelectedPopoverObject) {
          this.selectedExamDetailService.prevSelectedPopoverObject.toggle();
        }
        this.selectedExamDetailService.prevSelectedPopoverObject = null;
        this.selectedExamDetailService.outsidesClick = 0;
      }
    }
  }

  ngOnChanges(): void {
    this.ref.detectChanges();
    if (this.elSlotsWrpr) {
      this.elSlotsWrpr.nativeElement.focus();
    } else if (this.elLocationSelector) {
      this.elLocationSelector.nativeElement.focus();
    } else if (this.elCalendarWrpr) {
      this.elCalendarWrpr.nativeElement.focus();
    }
  }

  public getLocation(token: any): Observable<any> {
    return of(token);
  }

  /* Get valid start date */
  getValidStart(): Date {
    return this.utilityService.getValidStart(this.overLapStartDate);
  }

  /* Get valid start end date */
  getValidStartDateEnd(): Date {
    return this.utilityService.getValidStartDateEnd(this.overLapStartDate, this.overLapEndDate);
  }

  getAriaLabel(): string {
    return !!this.actionTxtAriaSupplement ? this.translate.instant(this.actionTxt) + ' ' + this.actionTxtAriaSupplement : this.translate.instant(this.actionTxt);
  }
}